import { Radio as FluentRadio } from "@fluentui/web-components";
/**
 * Radio
 * @summary A Radio Custom HTML Element based on Fluent UI's Radio with custom styling and behavior.
 *
 * @example
 * ```html
 * <fabric-radio name="group1" value="option1" checked>
 *   Option 1
 * </fabric-radio>
 * <fabric-radio name="group1" value="option2">
 *   Option 2
 * </fabric-radio>
 * ```
 *
 * @attr {boolean} autofocus - Indicates that the element should get focus after the page finishes loading.
 * @attr {boolean} disabled - The initial disabled state of the control.
 * @attr {string} form - The id of a form to associate the element to.
 * @attr {boolean} checked - The initial checked state of the element.
 * @attr {string} value - The initial value of the input.
 * @attr {string} name - The name of the element. This element's value will be surfaced during form submission under the provided name.
 *
 * @prop {boolean} autofocus - Indicates that the element should get focus after the page finishes loading.
 * @prop {boolean} disabled - The initial disabled state of the control.
 * @prop {string} form - The id of a form to associate the element to.
 * @prop {boolean} checked - The initial checked state of the element.
 * @prop {string} value - The initial value of the input.
 * @prop {string} name - The name of the element. This element's value will be surfaced during form submission under the provided name.
 *
 * @slot checked-indicator - Custom slot for the checked indicator.
 *
 * @csspart checked-indicator - The checked state indicator of the radio.
 * @cssprop --size - Controls the size of the radio control.
 *
 * @method toggleChecked - Toggles the checked state of the control.
 * @method checkValidity - Checks the validity of the element and returns the result.
 * @method reportValidity - Reports the validity of the element.
 * @method setCustomValidity - Sets a custom validity message.
 *
 * @fires change - Emits a custom change event when the checked state changes
 * @fires input - Emits a custom input event when the checked state changes
 * @fires disabled - Emits a custom event when the disabled state changes
 *
 * @extends FluentRadio
 * @tagname fabric-radio
 * @public
 */
export class Radio extends FluentRadio {
}
//# sourceMappingURL=radio.js.map